<mat-form-field>
  <mat-label>Mobilnummer</mat-label>
  <input #input="ngModel" [(ngModel)]="model" matInput spbPhoneValidator>

  @if (input.errors) {
    <mat-error>{{ input.errors['error'].message }}</mat-error>
  }

  @if (input.errors && input.touched) {
    <mat-icon matIconSuffix aria-hidden="true">
      priority_high
    </mat-icon>
  }

</mat-form-field>
